export default __webpack_public_path__ + "static/media/admin_product_sales_active.82b31c54.svg";